import Login from "./components/Login";
import EmployeeList from "./pages/EmployeeList";
import EmployeeDetail from "./pages/EmployeeDetail";
import ClientList from "./pages/ClientList";
import ClientDetail from "./pages/ClientDetail";
import InvoiceList from "./pages/InvoiceList";
import SetPassword from "./pages/SetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import ResetAuth from "./pages/ResetAuth";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import ChangePassword from "./pages/ChangePassword";
import NotFoundPage from "./pages/NotFound";
import MyProfile from "./pages/myProfile";
import Dashboard from "./pages/Dashboard";
import { Navigate, Route, Routes } from "react-router-dom";
import { useInitialNavigation, useSetLoginData } from "./hooks/useLoginSync";
import ProjectList from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";

const RouteNavigation = () => {
  useInitialNavigation();
  useSetLoginData();

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route path="/login" element={<Login />} />
      <Route path="/projects" element={<ProjectList />} />
      <Route path="/project/:id" element={<ProjectDetail />} />
      <Route path="/dashboard" element={<Dashboard />} />

      <Route path="/employees" element={<EmployeeList />} />
      <Route path="/employee/:id" element={<EmployeeDetail />} />

      <Route path="/clients" element={<ClientList />} />
      <Route path="/client/:id" element={<ClientDetail />} />

      <Route path="/invoices" element={<InvoiceList />} />
      <Route path="/settings" element={<Settings />} />

      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth-reset-password" element={<ResetAuth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />

      <Route path="/my-timesheet" element={<MyProfile />} />
      <Route path="/profile" element={<MyProfile />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default RouteNavigation;
